import { ComponentConfig } from '../../../config/route-config';

export const authenticated: ComponentConfig = {
};
export const unauthenticated: ComponentConfig = {

};
export const all: ComponentConfig = {

};